<template>
  <div
    id="editorSidebarForm"
    class="col-xl-4 col-lg-12 col-md-12"
    style="position: absolute; right: 0; top: 0"
  >
    <div class="card">
      <button class="btn btn-primary round" @click="show('steps')">
        생성목록
      </button>
      <!-- <button class="btn btn-primary round" @click="show('errors')">
        Errors
      </button> -->
      <button class="btn btn-primary round" @click="show('folder')">
        폴더설정
      </button>

      <div v-if="stepsForm">
        <!-- 일단 주석 (삭제x)
        <div class="input-group search sidebar-title">
          <input
            type="text"
            class="form-control"
            placeholder="Search here..."
          />
          <div class="input-group-append">
            <span class="input-group-text"
              ><i class="zmdi zmdi-search"></i
            ></span>
          </div>
        </div> -->
        <div class="table-responsive sidebar-title">
          <table class="table mb-0 table-borderless table-hover">
            <tbody>
              <tr v-for="(work, index) in workflowStore.workflowsS" :key="index">
                <td width="10px">
                  <img
                    class="workIcon"
                    :src="imagePaths(work.api.appImage)"
                  />
                </td>
                <td
                  v-if="work.type == 'trigger'"
                  @click="focusForm('editorForm' + index)"
                >
                  {{ index + 1 }}. 트리거
                </td>
                <td
                  v-if="work.type == 'action'"
                  @click="focusForm('editorForm' + index)"
                >
                  {{ index + 1 }}. 액션
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="errorsForm">
        <p class="sidebar-title">Your Workflow has no errors</p>
      </div>

      <div v-if="folderForm">
        <p class="sidebar-title">폴더</p>
        <select
          class="form-control show-tick"
          v-model="workflowStore.groupCode"
        >
          <!-- <option value="0" selected>Home</option> -->
          <option
            v-for="group in workflowStore.groups"
            :key="group.code"
            :value="group.groupCode"
            @change="changeGroup(group.groupCode)"
          >
            <span v-if="group.groupName.length > 20">{{
              group.groupName.substr(0, 20) + " ..."
            }}</span>
            <span v-else>{{ group.groupName }}</span>
          </option>
        </select>
        <!-- <p class="sidebar-title">설명</p> -->
        <!-- <textarea rows="3" class="form-control no-resize"></textarea> -->
        <!-- <p class="sidebar-title">Timezone</p> -->
        <!-- <select class="form-control show-tick">
          <option value="" disabled selected>select timezone</option>
          <option value="seoul">GMT+09:00 Asia/Seoul</option>
        </select> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  data() {
    return {
      stepsForm: true,
      errorsForm: false,
      folderForm: false,
      groups: [],
      // groupCode: "0",
      groupCode: "",
      groupName: "Home",
      modelTest: "",
      defaultGroup: "Home",
    };
  },
  computed: {
    userStore() {
      return this.$store.state.userStore;
    },
    workflowStore() {
      return this.$store.state.workflowStore;
    },
  },
  created() {},
  methods: {
    show(name) {
      // if (name == "errors") {
      //   this.errorsForm = true;
      //   this.folderForm = false;
      //   this.stepsForm = false;
      // }
      if (name == "folder") {
        this.folderForm = true;
        this.errorsForm = false;
        this.stepsForm = false;
      }
      if (name == "steps") {
        this.folderForm = false;
        this.errorsForm = false;
        this.stepsForm = true;
      }
    },
    saveSidebarParams() {
      if (this.groupCode != "") {
        this.workflowStore.groupCode = this.groupCode;
      }
    },
    changeGroup(code) {
      this.$store.dispatch("saveGroupCode", code);
    },
    focusForm(name) {
      document.getElementById(name).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    },
    imagePaths(value) {
      if (value != null && value != "") {
        return (
          "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
          value
        );
      } else {
        return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
      }
    },
  },
};
</script>
